import { get, post } from "@insite/client-framework/Services/ApiService";

const rockwellConfiguratorAPIUrl = "api/v2/add2cartusingrockwellcid";

export async function getRockwellConfiguredProductsUsingConfigurationId(configurationId: string) {
    const rockwellConfiguratorWebAPIUrl = `${rockwellConfiguratorAPIUrl}/${configurationId}`;

    try {
        const accountModel = await post<any>(`${rockwellConfiguratorWebAPIUrl}`, {});
        return {
            result: accountModel,
            successful: true,
        };
    } catch (error) {
        if ("status" in error && error.status === 400 && error.errorJson && error.errorJson.message) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}
